import { createSelector } from 'reselect';

import { draftModuleSelector } from '../utils';

export const linksSelector = createSelector(draftModuleSelector, (state) => state.links);
